// Single consolidated "QA/internal" build (SHFT-5757), replacing the old
// per-flavor dev/staging/dev-alt-1..15 build configurations.
//
// The values below (apiUrl/socketUrl/firebaseTenantId) are vestigial fallback
// values only - same "dev" tier as environment.dev.ts. At runtime, before
// Angular bootstraps, src/main.ts fetches the `environment_directory` Remote
// Config parameter, shows a picker so a QA user can choose which backend
// (dev / staging / prod / dev-alt-1..15) to point at, and mutates this
// environment object in place with the resolved apiUrl/socketUrl/
// firebaseTenantId before calling bootstrapModule. See src/app/shared/env-switcher.ts.
import { environment as baseEnv } from './environment.dev';

export const environment = {
  ...baseEnv,
  isInternalBuild: true,
};
